export const GET_BIKE_MODELS_LEAD_CREATE_REQUEST = 'GET_BIKE_MODELS_LEAD_CREATE_REQUEST';
export const GET_BIKE_MODELS_LEAD_CREATE_REQUEST_SUCCESS = 'GET_BIKE_MODELS_LEAD_CREATE_REQUEST_SUCCESS';
export const GET_BIKE_MODELS_LEAD_CREATE_REQUEST_FAILURE = 'GET_BIKE_MODELS_LEAD_CREATE_REQUEST_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_create/redux/constants/get_bike_models.constants.js